export enum GasMeterDetailField {
  DeviceCategory = 'deviceCategory',
  MeasurementCategory = 'measurementCategory',
  Orientation = 'orientation',
  GSize = 'gSize',
  DiameterNominal = 'diameterNominal',
  LayLength = 'layLength',
  PMax = 'pMax',
  QMin = 'qMin',
  QMax = 'qMax',
}
